export default __webpack_public_path__ + "static/media/69t.dc3da077.jpg";